import React from 'react';

export function Slovakia(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="white"/>
      <path d="M0 114H513V228H0V114Z" fill="#0B4EA2"/>
      <path d="M0 228H513V342H0V228Z" fill="#EF3340"/>
      <path d="M60,80 L60,220 Q60,260 110,260 Q160,260 160,220 L160,80Z" fill="white" stroke="#EF3340" strokeWidth="3"/>
      <path d="M60,80 L60,220 Q60,260 110,260 Q160,260 160,220 L160,80Z" fill="#EF3340"/>
      <rect x="95" y="130" width="30" height="60" fill="white"/>
      <rect x="80" y="145" width="60" height="30" fill="white"/>
    </svg>
  );
}
